import {
	Modal, Col, Table, Pagination
}from 'antd'
import {
	useEffect,
	useState
}from 'react'
import {
	Scrollbars
}from "react-custom-scrollbars"
import "antd/lib/spin/style/index.css"
import {
	useSelector, useDispatch
}from 'react-redux'
import {
	organizationConstructionMaterialPriceChangeActions
}from '../OrganizationConstructionMaterialPriceChange/store/actions'
import moment from "moment"
import CustomFilters from '../../components/CustomFilters'
import {
	rePriceFormationOrderActions
}from '../NRI/RePriceFormationOrder/store/actions'
import LocalLoading from '../../components/Loading/Local'
import "./style.css"
import {
	Resizable
}from 'react-resizable'

const ResizableTitle = (props) => {
	const { onResize, width, render, className, ...restProps } = props
	if (!width){
		return (
			<th
				 className="ant-table-cell ant-table-cell-fix-left ant-table-cell-fix-left-last"
				{ ...restProps }
			/>
		)
	}

	return (
		<Resizable
			draggableOpts={ {
				enableUserSelectHack: false
			} }
			handle={
				(
					<span
						className="react-resizable-handle"
						onClick={ (e) => {
							e.stopPropagation()
						} }
					>
					</span>
				)
			}
			height={ 0 }
			width={ width }
			onResize={ onResize }
		>
			<th
				{ ...restProps }
				className={ `${ className } column` }
			/>
		</Resizable>
	)
}

const ModalActuallMaterialPrice = ({ visible, setVisible, materialId, regions }) => {
	const { paged, isSending } = useSelector(state => state.organizationConstructionMaterialPriceChangeReducer)
	const { list : formationOrders } = useSelector(state => state.rePriceFormationOrderReducer)
	const [filter, setFilter] = useState(null)
	const [page, setPage] = useState(1)
	const [table, setTable] = useState([])
	const [count, setCount] = useState(0)
	const [columns, setColumns] = useState([
		{
			dataIndex : 'changeDate',
			key       : 'changeDate',
			title     : 'Дата представления цены',
			width     : 100,
			render    : (changeDate) => {
				return moment(changeDate).format('DD.MM.YYYY')
			}
		},
		{
			dataIndex : 'orgName',
			inputType : 'text',
			key       : 'orgName',
			title     : 'Название организации',
			width     : 250
		},
		{
			key       : 'factoryName',
			inputType : 'text',
			dataIndex : 'factoryName',
			title     : 'Название материала в рамках организации',
			width     : 250
		},
		{
			dataIndex : 'region',
			inputType : 'text',
			key       : 'region',
			title     : 'Регион реализации',
			width     : 100
		},
		{
			dataIndex : 'priceFormationName',
			inputType : 'text',
			key       : 'priceFormationName',
			title     : 'Порядок формирования цены',
			width     : 150
		},
		{
			dataIndex : 'price',
			inputType : 'text',
			key       : 'price',
			title     : 'Цена',
			width     : 100
		},
		{
			dataIndex : 'notice',
			inputType : 'text',
			key       : 'notice',
			title     : 'Примечание',
			width     : 400
		}
	])

	const dispatch = useDispatch()
	const pageSize = 10

	const handleCancel = () => {
		setFilter(null)
		setVisible(false)
	}

	const getInfo = (values) => {
		dispatch(organizationConstructionMaterialPriceChangeActions.getLastPricePaged(values))
	}

	const onPaginationChange = (value) => {
		setPage(value)
		getInfo({
			materialId         : materialId,
			page               : value,
			pageSize           : pageSize,
			regions            : filter?.regions,
			orgName            : filter?.orgName,
			rePriceFormationId : filter?.rePriceFormation,
			startDate          : filter?.date && filter?.date[0] ? (moment(filter?.date[0])?.format('MM.DD.YYYY')) : null,
			endDate            : filter?.date && filter?.date[1] ? (moment(filter?.date[1])?.format('MM.DD.YYYY')) : null
		})
	}

	useEffect(() => {
		return () => {
			dispatch(organizationConstructionMaterialPriceChangeActions.clear())
			dispatch(rePriceFormationOrderActions.clear())
		}
	}, [])

	useEffect(() => {
		if (visible){
			setPage(1)
			getInfo({
				materialId : materialId,
				page       : page,
				pageSize   : pageSize
			})
			dispatch(rePriceFormationOrderActions.getList())
		}
	}, [visible])

	useEffect(() => {
		if (visible)
			onPaginationChange(1)
	}, [filter])

	useEffect(() => {
		if (paged?.items){
			setCount(paged.count)
			setTable(paged.items)
		}
	}, [paged])

	const mergeColumns = columns.map((col, index) => ({
		...col,
		onHeaderCell: (column) => ({
			width    : column.width,
			onResize : handleResize(index)
		})
	}))

	const handleResize =
	(index) => (obj, { size }) => {
		const newColumns = [...columns]
		newColumns[index] = { ...newColumns[index],
			width: size.width }
		setColumns(newColumns)
	}

	return (
		<Modal
			footer={ null }
			title="Цена строительного материала в организациях"
			visible={ visible }
			width={ 1500 }
			onCancel={ handleCancel }
		>
			{ /* <Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 600 }
			> */ }
			<Col>
				<CustomFilters
					elements={ [
						{
							name        : "orgName",
							type        : "input",
							placeholder : "Введите название организации"
						},
						{
							name        : "rePriceFormation",
							type        : "select",
							placeholder : "Выберите порядок формирования цены",
							items       : formationOrders,
							itemName    : ["name"]
						},
						{
							name        : "regions",
							type        : "select",
							multiple    : true,
							placeholder : "Выберите регионы реализации материала",
							items       : regions,
							itemName    : ["name"]
						},
						{
							name : "date",
							type : "datePicker"
						}
					] }
					setFilters={ setFilter }
				/>
			</Col>
			<Col>
				<Table
					bordered
					className="table-border"
					columns={ mergeColumns }
					components={ {
						header: {
							cell: ResizableTitle
						}
					} }
					dataSource={ table }
					loading={ { indicator : <LocalLoading />,
						spinning  : isSending } }
					pagination={ false }
					scroll={ { x : 1100,
						y : 450 } }
				/>
				<div
					className="org-materials-table"
					span={ 16 }
				>
					{ count > pageSize
						? (
							<Pagination
								showQuickJumper
								current={ page }
								pageSize={ pageSize }
								showSizeChanger={ false }
								total={ count }
								onChange={ onPaginationChange }
							/>)
						: null }
				</div>
			</Col>
			{ /* </Scrollbars> */ }
		</Modal>
	)
}

export default ModalActuallMaterialPrice